import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const societyAmenities = createAsyncThunk(
  "societyAmenities",
  async (id) => {
    try {
      const cookies = new Cookies();
      const token = cookies.get("token");
      const response = await AxiosInstance.get(`${API_KEY}/api/amenity/society/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        "Content-Type": "application/json",
      });
      return response;
    } catch (error) {
      if (error.response) {
        throw error.response.data.message;
      } else {
        throw error;
      }
    }
  }
);

const initialState = {
  isLoading: false,
  societyAmenitiesData: null,
  isError: false,
  errorMessage: "",
};

const societyAmenitiesSlice = createSlice({
  name: "societyAmenities",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyAmenities.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyAmenities.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyAmenitiesData = action.payload;
    });
    builder.addCase(societyAmenities.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyAmenitiesSlice.reducer;
